var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
      attrs: {
        "aria-labelledby": "mobile-navigation-toggler",
        role: "navigation",
        itemscope: "",
        itemtype: "https://schema.org/SiteNavigationElement",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
        },
        [
          _c(
            "ul",
            {
              staticClass:
                "acclang d-flex list-unstyled justify-content-between mb-0",
            },
            [
              _c(
                "li",
                { staticClass: "font-weight-bold" },
                [
                  _c(
                    "client-only",
                    [
                      _c("user-login-handler", {
                        attrs: { id: "mobile-login-change" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "list-inline-item dropdown control-languages" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link text-uppercase font-weight-bold",
                      attrs: {
                        "data-toggle": "collapse",
                        href: "#mb-nav-countrySettings",
                        "aria-expanded": "false",
                        "aria-controls": "mb-nav-countrySettings",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.headerCountry"
                        ),
                        "data-parent": "#controlsList",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "flag-icon",
                        class: "flag-icon-" + _vm.lang,
                      }),
                      _vm._v("\n          " + _vm._s(_vm.lang) + "\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row cmp cmp-country-settings collapse",
                      attrs: { id: "mb-nav-countrySettings" },
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "d-flex flex-wrap" },
                        [
                          _vm._l(_vm.activeLanguages, function (lang) {
                            return [
                              _c(
                                "li",
                                {
                                  staticClass: "w-100",
                                  class: { active: lang === _vm.activeLang },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "p-3 nav-link d-inline-flex w-100",
                                      attrs: {
                                        "data-update-url": "",
                                        href: _vm.languageUrls[lang],
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "flag-icon mr-2",
                                        class: "flag-icon-" + lang,
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.header" +
                                                (lang[0].toUpperCase() +
                                                  lang.substring(1))
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "mobile-menu mainmenu d-block p-0 mb-0" }, [
            _c("li", { staticClass: "mobile-img-wrapper border-0" }, [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: _vm.mainCategories.images[
                    _vm.dataContainer1MainCategory.id
                  ],
                  alt: _vm.dataContainer1MainCategory.details[0].name,
                  loading: "lazy",
                  width: "1000",
                  height: "400",
                },
              }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "fs-mobile p-0 w-100 d-none",
                  class: { "d-inline-flex": !!_vm.dataContainer1.parent },
                },
                [
                  _vm._l(_vm.mainCategories.main, function (mainCategory) {
                    return [
                      _c(
                        "li",
                        {
                          key: mainCategory.id,
                          staticClass:
                            "firstlvl d-block text-center font-weight-bold",
                          class: {
                            active: _vm.hasParentCategoryId(
                              _vm.dataContainer1,
                              mainCategory.id
                            ),
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.slideTo(mainCategory)
                                },
                              },
                            },
                            [_vm._v(_vm._s(mainCategory.details[0].name))]
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("li", {
              staticClass: "btn-close",
              attrs: {
                "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
              },
              on: {
                click: function ($event) {
                  return _vm.closeNavigation()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "mobile-default-menu py-3 px-5 mb-0 list-unstyled",
              class: { "d-none": !!_vm.dataContainer1.parent },
            },
            [
              _c("li", [
                _c(
                  "h4",
                  {
                    staticClass:
                      "text-dark text-uppercase text-center pt-3 font-weight-bold",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$translate(
                            "modeherz::MobileNavigation.navigationMobileSearchProductsFor"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.mainCategories.main, function (mainCategory) {
                return [
                  _c(
                    "li",
                    {
                      staticClass: "d-block text-center font-weight-bold my-3",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-outline-primary w-100 text-dark py-3 text-uppercase font-weight-bold",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(mainCategory)
                            },
                          },
                        },
                        [_vm._v(_vm._s(mainCategory.details[0].name))]
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" },
            },
            [
              _vm.dataContainer1.parent && _vm.dataContainer1.parent.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function ($event) {
                          _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [_vm._m(0)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function (category) {
                return _c(
                  "li",
                  {
                    staticClass: "ddown",
                    class: {
                      invisible:
                        _vm.dataContainer1.parent -
                        _vm.dataContainer1.categories.length,
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "align-self-center",
                        attrs: {
                          itemprop: "name",
                          href: _vm.getCategoryUrl(category.url),
                        },
                      },
                      [_vm._v(_vm._s(category.details[0].name))]
                    ),
                    _vm._v(" "),
                    category.childCount && category.childCount < 20
                      ? _c(
                          "span",
                          {
                            staticClass: "nav-direction p-0 align-self-center",
                            on: {
                              click: function ($event) {
                                return _vm.slideTo(category)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-lg fa-chevron-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(
                    _vm.dataContainer1.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" },
            },
            [
              _vm.dataContainer1.parent &&
              _vm.dataContainer2.parent &&
              _vm.dataContainer1.parent.parent &&
              _vm.dataContainer2.parent.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function ($event) {
                          _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [_vm._m(1)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    {
                      staticClass: "align-self-center",
                      attrs: {
                        itemprop: "name",
                        href: _vm.getCategoryUrl(category.url),
                      },
                    },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount && category.childCount < 20
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction p-0 align-self-center",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(category)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-chevron-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(
                    _vm.dataContainer2.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "mainmenu w-100 p-0 m-0 menu-active" },
            [
              _vm._l(_vm.staticLinks.links, function (staticLink) {
                return [
                  _c(
                    "li",
                    {
                      key: staticLink.categoryId,
                      staticClass:
                        "link-list list-inline-item border-0 pt-4 pl-4",
                    },
                    [
                      _c(
                        "a",
                        { attrs: { href: staticLink.url, itemprop: "name" } },
                        [
                          _c("i", {
                            staticClass: "mr-3 text-center fa",
                            class: "fa-" + staticLink.icon,
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(_vm._s(staticLink.name)),
                        ]
                      ),
                    ]
                  ),
                ]
              }),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "link-list dropdown control-hotline border-0" },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "custom_btn_reverted d-flex align-items-center justify-content-center",
                      attrs: {
                        href: _vm.staticLinks.serviceUrl,
                        itemprop: "name",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-phone-alt fa-flip-horizontal mr-3",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "modeherz::Navigation.navigationCustomerServiceBtnText"
                          )
                        ) + "\n        "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }